<template>
	<div>
		<v-dialog v-model="dialog_phone_numbers" no-click-animation scrollable persistent transition="dialog-bottom-transition">
	      <v-card>
	      	<v-subheader full-width>Select Mobile Number
        		</v-subheader>
        		<v-divider></v-divider>
	        <v-list nopadding>
		        	<div v-for="(phoneNumber, index) in phoneNumbers" :key="index">
		        		
		        		<v-list-tile  @click="setPhoneNumber(phoneNumber)">
				            <v-list-tile-content>
				              <v-list-tile-title>{{phoneNumber}}</v-list-tile-title>
				            </v-list-tile-content>

			        	</v-list-tile>

			        	<v-divider v-if="phoneNumbers.length-1 != index"></v-divider>
		        	</div>		

		        </v-list>
		     <v-divider></v-divider>
		        <v-card-actions>
		          <v-spacer></v-spacer>
		          <v-btn color="blue darken-1" flat @click.native="$parent.fn_closeDialog()">close</v-btn>
		        </v-card-actions>
	      </v-card>
	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['phoneNumbers', 'setPhoneNumber'],
		data(){
			return{
				dialog_phone_numbers: false
			}
		},
		methods:{
			openDialogWeb: function () {
				this.dialog_phone_numbers = true;
			},
			closeDialogWeb: function () {
				this.dialog_phone_numbers = false;
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/masters/forms/ledgers/dialogs/dialog_phone_numbers.vue